// extracted by mini-css-extract-plugin
export default {"title":"jmHj54MJ","button":"fbhKM9cV","input":"xHOw9KUh"};